import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';
import './utils/KeeperFix'; // Load error suppression early
import './utils/viewportHeight'; // Fix iOS viewport height
import {QueryClient, QueryClientProvider} from "react-query";
// Memory leak detection disabled - remove console logs in production

const domNode = document.getElementById('root');
const root = createRoot(domNode);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    },
});

root.render(
    <>
        {/*<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"/>*/}
        <QueryClientProvider client={queryClient}>
            <App/>
        </QueryClientProvider>
    </>
);
